import { render, staticRenderFns } from "./StoryPointsRow.vue?vue&type=template&id=08167a47&scoped=true&"
import script from "./StoryPointsRow.vue?vue&type=script&lang=ts&"
export * from "./StoryPointsRow.vue?vue&type=script&lang=ts&"
import style0 from "./StoryPointsRow.vue?vue&type=style&index=0&id=08167a47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08167a47",
  null
  
)

export default component.exports